import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=6992b2a1&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=6992b2a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6992b2a1",
  null
  
)

export default component.exports